var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"contain":"","src":require("@/assets/custom/images/header-logo.png")}})
}
var staticRenderFns = []

export { render, staticRenderFns }